import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ModalPreviousEditionsComponent } from './../modal-previous-editions/modal-previous-editions.component';

@Component({
  selector: 'app-modal-transcription',
  templateUrl: './modal-transcription.component.html',
  styleUrls: ['./modal-transcription.component.scss']
})

export class ModalTranscriptionComponent implements OnInit {

  constructor(private dialog: MatDialog,
              public dialogRef: MatDialogRef<ModalTranscriptionComponent>)  { }
  
  ngOnInit(): void {
  }

  closeModal()
  {
    this.dialogRef.close();
  }

  openModalPreviousEditions(){
    const modalRef = this.dialog.open(ModalPreviousEditionsComponent, {
      width: '600px',
      maxHeight: '750px',
    });
  }
}

